import SMAssetBindingModal from './SMAssetBindingModal';
export default SMAssetBindingModal;